import { TransformConvertorBase } from './transform.convertor';
import { UnionTransformation } from 'app/model/dataflow/uniontransformation';
import { Transformation } from 'app/model/dataflow/transformation';
import { IResourceContext } from 'shell-models-lib';

export class UnionConvertor extends TransformConvertorBase {
    public async convert(contextData: IResourceContext): Promise<Transformation> {
        await super.convert(contextData);
        if (this.transformObject.configs.has('byName')) {
            (this.transformation as UnionTransformation).byName = this.transformObject.configs.get('byName') === 'true';
            this._handledConfigs.push('byName');
        }
        super.postConvert();
        return this.transformation;
    }
}
